import React, { useState } from "react";
import { SelectInput, type SelectOption } from "@SeemplicityDev/shared";
import {
  ACCOUNT_CONFIG_TYPES,
  ACCOUNT_CONFIG_TYPE_OPTIONS,
  isAccountConfigType,
  type AccountConfigTypeValue,
} from "./accountConfigTypes";
import "./AccountConfigs.scss";

interface AccountConfigsModalProps {
  accountUuid: string;
  accountName: string;
}

const AccountConfigsModal: React.FC<AccountConfigsModalProps> = ({
  accountUuid,
  accountName,
}) => {
  const [configType, setConfigType] = useState<AccountConfigTypeValue | null>(
    null
  );

  const SectionComponent = configType
    ? ACCOUNT_CONFIG_TYPES[configType].Component
    : null;

  return (
    <div
      className="account-configs-modal"
      data-testid={`account-configs-modal-${accountUuid}`}
    >
      <p className="account-configs-context">{accountName}</p>

      <SelectInput
        name="config-type"
        data-testid="account-configs-type"
        labelTop
        label="Configuration Type"
        placeholder="Select a configuration type"
        hideLabelHelper
        options={ACCOUNT_CONFIG_TYPE_OPTIONS}
        setDefaultSingleOption={false}
        value={
          ACCOUNT_CONFIG_TYPE_OPTIONS.find((opt) => opt.value === configType) ??
          null
        }
        onChange={(option: SelectOption | null) => {
          if (isAccountConfigType(option?.value)) {
            setConfigType(option.value);
          }
        }}
      />

      {SectionComponent ? (
        <SectionComponent accountUuid={accountUuid} />
      ) : (
        <p className="account-configs-empty">
          Select a configuration type to continue.
        </p>
      )}
    </div>
  );
};

export default AccountConfigsModal;
